export default __webpack_public_path__ + "static/text-styles-do-45a48787eaf5cce3191f0fb9e64dbfa7.png";